import ScrollableList from '~/view/components/ScrollableList/ScrollableList';
import { TProfile } from '~/view/containers/ProfilesList';
import { Profile } from '~/view/containers/ProfilesList/components/Profile/Profile';
import Profiles from '~/view/containers/ProfilesList/components/ProfilesWrapper/ProfilesWrapper';
import { appStore } from '~/mobx/appStore';
import { userStore } from '~/mobx/userStore';

type Props<T> = {
  pages: number[];
  list: T[];
  loading: boolean;
  last_page: number;
  current_page: number;
  wrapperClassName?: string;
  selectedProfileId?: number | null;
  fetch: (...args: any[]) => void;
  onAddProfile?: () => void;
  selectProfile: (profile: TProfile) => void;
  onUpdateName?: (profile: TProfile) => Promise<boolean | undefined> | boolean | undefined;
};

export const ProfilesLazyList = <T extends TProfile>(props: Props<T>) => {
  const getOnAddProfile = () => {
    if (appStore.settings?.is_deliverect_client && appStore.settings?.is_branch_profiles_locked && !userStore.user.service_user) {
      return undefined;
    }
    return props.onAddProfile;
  };

  return (
    <Profiles onAddProfile={getOnAddProfile()} wrapperClassName={props.wrapperClassName}>
      <ScrollableList<TProfile>
        pages={props.pages}
        list={props.list}
        loading={props.loading}
        last_page={props.last_page}
        current_page={props.current_page}
        fetch={props.fetch}
        emptyListInFooter={false}
        autoFetch={false}
        scrollToTop={false}
        scrollbar
        scrollbarSize="small"
        listClassName="gap-10"
        emptyListText="no_matching_profiles"
        renderItem={(profile) => (
          <Profile
            key={profile.id}
            profile={profile}
            selectedProfileId={props.selectedProfileId}
            selectProfile={props.selectProfile}
            onUpdateName={props.onUpdateName}
          />
        )}
      />
    </Profiles>
  );
};
